// extracted by mini-css-extract-plugin
module.exports = {"back-to-menu-editor":"_19Fm8","backToMenuEditor":"_19Fm8"};